module.exports = {
  // 是否开启多语言
  multiLanguage: '多语言',
  // 拒绝访问
  accessDenied: '拒绝访问',
  // 很抱歉，资源未找到
  notFound: '很抱歉，资源未找到',
  // 网络超时
  networkTimeout: '网络超时',
  // 未授权，请重新登录
  unauthorized: '未授权，请重新登录',
  // 登录已过期
  loginExpired: '登录已过期',
  // 重新登录
  reRegister: '重新登录',
  // 登陆已过期，重新登陆
  loginOut: '登陆已过期，重新登陆',
  // 系统服务错误
  systemServiceError: '系统服务错误',
  // 请求失败
  requestFailed: '请求失败',
  // 系统提示
  systemHint: '系统提示',
  // 请输入
  pleaseEnter: '请输入',
  // 请选择
  pleaseChoose: '请选择',
  pleaseSelectTenant: '请选择租户',
  // 该项为必填
  thisItemIsRequired: '该项为必填',
  // 自定义列
  customColumn: '自定义列',
  title: '动物管理系统', // 动物管理系统
  company: '上海楫智牧业科技有限公司', // 上海楫智牧业科技有限公司
  help: '帮助', // 帮助
  privacy: '隐私', // 隐私
  clause: '条款', // 条款
  produce: '出品', // 出品
  welcome: '欢迎您', // 欢迎您
  welcomeBack: '欢迎回来', // 欢迎回来
  welcomeToTheSmartFarmSystem: '欢迎使用动物管理系统', // 欢迎使用动物管理系统
  currentEnvironmentIs: '当前环境为：', // 当前环境为：
  currentLoginCompanyIs: '当前登录公司为：', // 当前登录公司为：
  searchMenu: '搜索菜单', // 搜索菜单
  systemSettings: '系统设置', // 系统设置
  changePassword: '密码修改', // 密码修改
  switchDepartment: '切换部门', // 切换部门
  cleanCache: '清理缓存', // 清理缓存
  goodMorning: '上午好',//上午好
  goodMornings: '早上好',//早上好
  goodAfternoon: '中午好',//中午好
  goodAfternoons: '下午好',//下午好
  goodEvening: '晚上好',//晚上好
  languageSwitching: '语言切换',//语言切换
  mainLanguage: '主语言',//主语言
  subLanguage: '次语言',//次语言
  overallStyleSetting: '整体风格设置',//整体风格设置
  darkMenuStyle: '暗色菜单风格',//暗色菜单风格
  brightMenuStyle: '亮色菜单风格',//亮色菜单风格
  themeColor: '主题色',//主题色
  navigationMode: '导航模式',//导航模式
  sidebarNavigation: '侧边栏导航',//侧边栏导航
  topBarNavigation: '顶部栏导航',//顶部栏导航
  topBarNavigationTip: '该设定仅 [顶部栏导航] 时有效',//该设定仅 [顶部栏导航] 时有效
  fixed: '固定',//固定
  flowType: '流式',//流式
  contentAreaWidth: '内容区域宽度',//内容区域宽度
  fixedHeader: '固定 Header',//固定 Header
  hideHeaderWhenSliding: '下滑时隐藏 Header',//下滑时隐藏 Header
  fixedSideMenu: '固定侧边菜单',//固定侧边菜单
  otherSettings: '其他设置',//其他设置
  colorWeakMode: '色弱模式',//色弱模式
  multiTabMode: '多页签模式',//多页签模式
  settingTips: '配置栏只在开发环境用于预览，生产环境不会展现，请手动修改配置文件',//配置栏只在开发环境用于预览，生产环境不会展现，请手动修改配置文件
  home: '首页',//首页
  shuaxin: '刷新',//刷新
  guanbizuoce: '关闭左侧',//关闭左侧
  guanbiyouce: '关闭右侧',//关闭右侧
  guanbiqita: '关闭其他'//关闭其他
}